import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

export const formatDate = (date: Date): string => {
  return format(date, "dd/MM/yyyy");
};

export const formatDateTimeString = (date: Date): string => {
  if (!date) {
    return "";
  }

  return format(date, "dd/MM/yyyy 'às' HH:mm:ss");
};

export const formatDateTime = (date?: string, time?: string): Date => {
  if (!date || !time) {
    return new Date();
  }

  return new Date(`${date.split("/").reverse().join("-")}T${time}`);
};

export const formatDateWithNameMonth = (date: Date): string => {
  const formattedDate = format(date, "dd MMM yyyy 'às' HH:mm:ss", {
    locale: ptBR
  });
  return formattedDate.replace(/[a-zA-Z]+/, (month) => month.toUpperCase());
};

export const getCurrentDateTime = () => {
  const dataAtual = new Date();

  const horas = String(dataAtual.getHours()).padStart(2, "0");
  const minutos = String(dataAtual.getMinutes()).padStart(2, "0");
  const segundos = String(dataAtual.getSeconds()).padStart(2, "0");

  const strHoraLocal = `${horas}:${minutos}:${segundos}`;

  dataAtual.setHours(0, 0, 0, 0);

  const datDataLocal = dataAtual.toISOString().split("T")[0] + "T00:00:00";

  return { datDataLocal, strHoraLocal };
};

export const formatDateWithCurrentDay = (date: Date) => {
  const dayOfWeek = format(date, "EEEE", { locale: ptBR });
  const formattedDay = dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.slice(1);
  const formattedDate = format(date, "dd/MM/yyyy", { locale: ptBR });

  return `${formattedDay}, ${formattedDate}`;
};
